<div class="confirmation-modal" (keydown)="onKeyDown($event)" tabindex="0">
  <!-- Progress Steps -->
  @if (config.steps.length > 1) {
    <div class="steps-container">
      <nz-steps [nzCurrent]="currentStep - 1" nzSize="small" class="mb-4">
        @for (step of config.steps; track step; let i = $index) {
          <nz-step [nzTitle]="'Step ' + (i + 1)"
            [nzDescription]="step.title">
          </nz-step>
        }
      </nz-steps>
    </div>
  }

  <!-- Modal Content -->
  <div class="modal-content">
    <!-- Step Title -->
    <div class="step-header mb-3">
      <h4 class="step-title">{{ currentStepConfig.title }}</h4>
      @if (config.steps.length > 1) {
        <div class="step-progress">
          <nz-progress [nzPercent]="stepProgress" nzSize="small" nzStatus="active">
          </nz-progress>
        </div>
      }
    </div>

    <!-- Step Content -->
    <div class="step-content">
      <!-- Basic Content Message -->
      @if (currentStepConfig.content) {
        <div class="content-message mb-3">
          <nz-alert [nzType]="isCurrentStepDestructive ? 'warning' : 'info'" [nzMessage]="currentStepConfig.content"
            nzShowIcon>
          </nz-alert>
        </div>
      }

      <!-- Dispatch Details (Step 1) -->
      @if (currentStepConfig.showDispatchDetails && config.dispatch) {
        <div class="dispatch-details">
          <nz-card nzTitle="Dispatch Details" nzSize="small" class="mb-3">
            <div class="details-grid">
              <div class="detail-item">
                <label>Packing Number:</label>
                <span class="fw-bold">{{ config.dispatch.PackingNumber }}</span>
              </div>
              <div class="detail-item">
                <label>Customer:</label>
                <span>{{ config.dispatch.CustomerName }}</span>
              </div>
              <div class="detail-item">
                <label>Transport:</label>
                <span>{{ config.dispatch.TransportName }}</span>
              </div>
              <div class="detail-item">
                <label>Vehicle:</label>
                <span>{{ config.dispatch.VehicleNumber }}</span>
              </div>
              <div class="detail-item">
                <label>Quantity:</label>
                <span>{{ config.dispatch.DispatchQuantity || 'N/A' }}</span>
              </div>
              <div class="detail-item">
                <label>Dispatch Date:</label>
                <span>{{ config.dispatch.DispatchDate | date:'medium' }}</span>
              </div>
              <div class="detail-item">
                <label>Status:</label>
                <nz-tag [nzColor]="config.dispatch.ApprovalStatus === 'Approved' ? 'success' : 'warning'">
                  {{ config.dispatch.ApprovalStatus }}
                </nz-tag>
              </div>
              @if (config.dispatch.IsStockRemoved) {
                <div class="detail-item">
                  <label>Stock Status:</label>
                  <nz-tag nzColor="processing">Stock Removed</nz-tag>
                </div>
              }
            </div>
          </nz-card>
        </div>
      }

      <!-- Stock Impact Information (Step 2) -->
      @if (currentStepConfig.showStockImpact && stockImpactInfo) {
        <div class="stock-impact">
          <nz-card nzTitle="Stock Impact" nzSize="small" class="mb-3">
            <div class="impact-info">
              <div class="impact-message mb-3">
                <nz-alert nzType="warning" [nzMessage]="stockImpactInfo.impactMessage" nzShowIcon>
                </nz-alert>
              </div>
              @if (stockImpactInfo.affectedItems.length > 0) {
                <div class="affected-items">
                  <h6>Affected Items:</h6>
                  <nz-table #affectedItemsTable [nzData]="stockImpactInfo.affectedItems" nzSize="small"
                    [nzShowPagination]="false">
                    <thead>
                      <tr>
                        <th>Dispatch Number</th>
                        <th>Quantity</th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (item of affectedItemsTable.data; track item) {
                        <tr>
                          <td>{{ item.packingNumber }}</td>
                          <td>{{ item.quantity }} {{ item.unit }}</td>
                        </tr>
                      }
                    </tbody>
                  </nz-table>
                </div>
              }
            </div>
          </nz-card>
        </div>
      }

      <!-- Reason Collection (Final Step) -->
      @if (currentStepConfig.requiresReason) {
        <div class="reason-collection">
          <form [formGroup]="reasonForm" nzLayout="vertical">
            <nz-form-item>
              <nz-form-label nzRequired>Cancellation Reason</nz-form-label>
              <nz-form-control [nzErrorTip]="reasonErrorMessage">
                <textarea nz-input formControlName="reason" [placeholder]="config.reasonPlaceholder" [rows]="4"
                  [attr.maxlength]="config.reasonMaxLength" class="reason-textarea">
                </textarea>
                @if (config.reasonMaxLength) {
                  <div class="character-count mt-1">
                    <small class="text-muted">{{ reasonCharacterDisplay }}</small>
                  </div>
                }
              </nz-form-control>
            </nz-form-item>
          </form>
          <!-- Validation Feedback -->
          @if (reasonValidation && !reasonValidation.isValid) {
            <div class="validation-feedback">
              <nz-alert nzType="error" [nzMessage]="reasonValidation.errorMessage" nzShowIcon class="mt-2">
              </nz-alert>
            </div>
          }
        </div>
      }
    </div>
  </div>

  <!-- Modal Footer -->
  <div class="modal-footer">
    <div class="footer-actions">
      <!-- Previous Button -->
      @if (!isFirstStep && config.steps.length > 1) {
        <button nz-button nzType="default" (click)="onPreviousStep()"
          class="me-2">
          <i nz-icon nzType="left"></i>
          Previous
        </button>
      }

      <!-- Cancel Button -->
      <button nz-button nzType="default" (click)="onCancel()" [disabled]="isLoading" class="me-2">
        Cancel
      </button>

      <!-- Action Button -->
      <button nz-button [nzType]="currentButtonType" [nzDanger]="isCurrentStepDestructive" [nzLoading]="isLoading"
        (click)="onStepAction()" [disabled]="currentStepConfig.requiresReason && !isReasonValid()">
        @if (isCurrentStepDestructive && !isLoading) {
          <i nz-icon nzType="warning"></i>
        }
        {{ currentButtonText }}
      </button>
    </div>
  </div>
</div>